import { NotificationLogoProps } from ".";
import { CustomerLogo } from "@lib/components/MiniComponents/Others";
import { CustomerBillingPayload } from "@lib/types/Notification";
import { PiGitPullRequestLight } from "react-icons/pi";

export default function CustomerPayBillRequestLogo(
  props: NotificationLogoProps,
) {
  const { notification, onlyIcon = false } = props;
  const payload = notification?.payload as CustomerBillingPayload;
  const customer = { ...payload?.customer, ...payload?.wallet?.customer };

  if (onlyIcon) {
    return <PiGitPullRequestLight />;
  }

  return <CustomerLogo customer={customer} />;
}
